import { FC } from 'react';

import { ShareButton } from './ShareButton';

interface ShareSocialsProps {
  onClick: (platform: string) => void;
  text: string;
  url: string;
}

export const ShareSocials: FC<ShareSocialsProps> = ({ onClick, text, url }) => {
  const encodedText = encodeURIComponent(text);

  const urlBySource = (platform: 'twitter' | 'facebook') => {
    if (platform === 'twitter') {
      const uri = encodeURIComponent(`${url}&utm_source=twitter`);
      return `https://twitter.com/intent/tweet?text=${encodedText}&url=${uri}&via=avant_arte`;
    }
    if (platform === 'facebook') {
      const uri = encodeURIComponent(`${url}&utm_source=facebook`);
      return `https://www.facebook.com/sharer/sharer.php?u=${uri}`;
    }
    return '';
  };

  return (
    <>
      <ShareButton
        href={urlBySource('twitter')}
        icon="ic_twitter"
        label="Twitter"
        onClick={() => onClick('twitter')}
      />
      <ShareButton
        href={urlBySource('facebook')}
        icon="ic_facebook"
        label="Facebook"
        onClick={() => onClick('facebook')}
      />
    </>
  );
};
